import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import OrgStruct from '../../../assets/img/IITTP/institute/orgstrct.png';

function Main() {
    return(
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Administration"/>
            <section className="project-detail">
                <div className='container'>
                    <div className="c-heading">  
                        <h1> Organizational Structure</h1> <br />
                        <img src={OrgStruct} alt='Organizational Structure' />
                    </div> 
                    
                </div>
            </section>
        </>
    );
}

export default Main;